import React, { useState } from 'react';
import {
  Paper,
  CircularProgress,
  Grid,
  Typography,
  Box,
  FormLabel,
  Button,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import ApiService from '../../services/ApiService';
import helpers from '../AddAnomaly/FileUploader/Helpers';
import GenericFileUploaderPage from '../GenericFileUploader/GenericFileUploadPage';
import SuccessUpdateAlert from '../TicketDetails/SuccessUpdateAlert';
import TechnicalErrorAlert from '../TechnicalErrorAlert/TechnicalErrorAlert';
import { userInfoState } from '../HomePage/HomeSlice';

const FileSaver = require('file-saver');

export default function ParametersScrapingPage() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [bfile, setBfile] = useState(null);
  const [displaySuccessPopup, setDisplaySuccessPopup] = useState(false);
  const [openTechnicalErrorAlert, setOpenTechnicalErrorAlert] = useState(false);
  const [fileName, SetFileName] = useState();
  const user = useSelector(userInfoState);
  const userEmail = user.email;

  const setFileToUpload = (fileToUpload) => {
    SetFileName(fileToUpload.name);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(fileToUpload);
    fileReader.onload = () => {
      const str =
        'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
      const newResult = fileReader.result.replace(str, '');
      setBfile(newResult);
    };
  };

  const uploadFile = () => {
    if (!bfile) {
      setOpenTechnicalErrorAlert(true);
      return;
    }
    setLoading(true);
    const nData = helpers.base64toBlob(bfile);
    ApiService.uploadParametersScrapingFile(nData, fileName, userEmail)
      .then(() => {
        setLoading(false);
        setDisplaySuccessPopup(true);
      })
      .catch((error) => {
        console.log('uploading error', error);
        setLoading(false);
      });
  };

  const downloadFile = () => {
    setLoading(true);
    ApiService.getParametersScrapingFile()
      .then((response) => {
        const { ctype } = response.headers;
        const ndata = helpers.base64toBlob(response.data);
        const blob = new Blob([ndata], { type: ctype });
        const { fname } = response.headers;
        FileSaver.saveAs(blob, fname);
        setLoading(false);
      })
      .catch((error) => {
        console.log('downloading error', error);
        setLoading(false);
      });
  };

  const closeSuccessPopUp = () => {
    setDisplaySuccessPopup(false);
  };

  const handleCloseTechnicalErrorAlert = () => {
    setOpenTechnicalErrorAlert(false);
  };

  return (
    <div className={classes.root}>
      {loading && (
        <Paper elevation={0} position="absolute" zindex="2">
          <CircularProgress className={classes.loader} />
        </Paper>
      )}
      <Grid container spacing={0}>
        <Typography className={classes.title}>
          {t('parameter_scraping')}
        </Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <Grid container item xs={12} className={classes.gridMarginSmall}>
            <div className={classes.contentCriticityDescription}>
              <p>{t('parameter_scraping_para1')}</p>
              <p>{t('parameter_scraping_para2')}</p>
            </div>
            <Grid container item xs={6} className={classes.gridMarginSmall}>
              <div className={classes.contentBlocks}>
                <FormLabel className={classes.titleBlack}>
                  {t('upload_new_parameter_scraping')}
                </FormLabel>
                <div className={classes.contentFileUpload}>
                  <GenericFileUploaderPage setFileCallBack={setFileToUpload} />
                </div>
                <div className={classes.fileUploadButton}>
                  <Box>
                    <Button
                      disabled={loading}
                      onClick={uploadFile}
                      color="secondary"
                      variant="contained"
                      fullWidth
                    >
                      {t('upload')}
                    </Button>
                  </Box>
                </div>
              </div>
            </Grid>
            <Grid container item xs={6} className={classes.gridMarginSmall}>
              <div className={classes.contentBlocks}>
                <FormLabel className={classes.titleBlack}>
                  {t('download_new_parameter_scraping')}
                </FormLabel>
                <div className={classes.fileDownloadButton}>
                  <Box>
                    <Button
                      disabled={loading}
                      onClick={downloadFile}
                      color="secondary"
                      variant="contained"
                      fullWidth
                    >
                      {t('download')}
                    </Button>
                  </Box>
                </div>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <SuccessUpdateAlert
        successPopup={displaySuccessPopup}
        successMessage={t('upload success')}
        handleCloseSuccessUpdateAlert={closeSuccessPopUp}
      />
      <TechnicalErrorAlert
        openTechnicalErrorAlert={openTechnicalErrorAlert}
        technicalErrorMessage={t('upload failed')}
        handleCloseTechnicalErrorAlert={handleCloseTechnicalErrorAlert}
      />
    </div>
  );
}
